import React from 'react';
import { Court } from '../components';

export default () => {
    return (
        <Court.Home />
    )
}